/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LoginType {
    Local = 0,
    Shibboleth = 1,
    LDAP = 2,
    OpenIdConnect = 3,
    LMS = 4,
}
